module.exports = __webpack_public_path__ + "img/logo-mamreq2.ed447bec.png";